import { isBlank } from 'lib/string';

// based on elasticsearch/lucene reserved chars that aren't escaped by ccs search api
export const RESERVED_CHARS = [
  '~',
  '^',
  '=',
  '?',
  '*',
  '|',
  '{',
  '}',
  '[',
  ']',
  '(',
  ')',
  '<',
  '>',
  '"',
  '\\'
];

const RESERVED_REGEX = new RegExp(`(${RESERVED_CHARS.map(c => `\\${c}`).join('|')})`);

/**
 * validates name string.
 * @param {object} name - name of this component
 * @param {string} type - page or component
 * @returns {Array} returns array of validation failures.
 */
const validateName = function validateName(name, type) {
  if (isBlank(name)) {
    return `${type} name is required.`;
  } else if (name.length < 3 || name.length > 300) {
    return 'Name length must be between 3 and 300 characters.';
  } else if (!RESERVED_REGEX.test(name)) {
    return undefined;
  }

  const [char] = RESERVED_REGEX.exec(name);
  return `Unsupported special character found in name: '${char}'`;
};

/**
 * validates name string.
 * @param {object} name - name of this component
 * @returns {string} returns array of validation failures.
 */
export const validateComponentName = function validateComponentName(name) {
  const validationMessage = validateName(name, 'Component');
  if (validationMessage) {
    return validationMessage;
  }

  return undefined;
};

/**
 * validates name string for page.
 * @param {object} name - name of this component
 * @returns {Array} returns array of validation failures.
 */
export const validatePageName = function validatePageName(name) {
  const validationMessage = validateName(name, 'Page');
  if (validationMessage) {
    return [validationMessage];
  }
  return [];
};
